<template>
    <div id="create-form">
        <h1>Create Form</h1>

        <p><router-link :to="{ name: 'AllForm', params: { id: this.$route.params.client_id } }">Return to forms</router-link></p>

        <notification v-bind:notifications="notifications"></notification>
        <!-- <form> -->
        <form v-on:submit.prevent="addForm">

            <div class="form-group">
                <label name="form_name">Name</label>
                <input type="text" class="form-control" v-model="form.name_en" id="form_name" required>
            </div>

            <div class="form-group">
                <label name="form_description_en">Description</label>
                <input type="text" class="form-control" v-model="form.description_en" id="form_description_en" required>
            </div>
            
            <div class="form-group">
                <label name="form_category">Category</label>
                <input type="text" class="form-control" v-model="form.category" id="form_category" required>
            </div>
            <div class="form-group">
                <label name="form_form_type">Type</label>
                <input type="text" class="form-control" v-model="form.form_type" id="form_form_type" >
            </div>
            <div class="form-group">
                <label name="form_design_path">Design Path</label>
                <input type="text" class="form-control" v-model="form.design_path" id="form_design_path" >
            </div>
            

            <div class="form-group">
                <label name="form_image_url">Image</label>
                <div v-if="!image">
                Select an image
                        <input type="file" class="form-control" @change="onFileChange">
                </div>
                <div v-else>
                    <img :src="image" />
                    <button @click="removeImage">Remove image</button>
                </div>
                <!-- <input type="text" class="form-control" v-model="form.thumbnail" id="form_thumbnail" required> -->
            </div>

            <div class="form-group">
                <button class="btn btn-primary">Create</button>
            </div>
        </form>
    </div>
</template>

<script>

import Notification from '../notifications.vue';
import Axios from 'axios';
import { BACKEND_URL } from '../../variables';
export default{
    data(){
        return{
            form:{},
            notifications:[],
            image: '',
        }
    },
    methods: {
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.form.file = files[0];
            this.createImage(files[0]);
            },
            createImage(file) {
            var image = new Image();
            var reader = new FileReader();
            var vm = this;

            reader.onload = (e) => {
                vm.image = e.target.result;
            };
            reader.readAsDataURL(file);
            },
            removeImage: function (e) {
            this.image = '';
            },

        addForm: function()
        {
            var formData = new FormData();

            formData.append('name_en', this.form.name_en);
            formData.append('description_en', this.form.description_en);
            formData.append('status', 'suspended');
            formData.append('category', this.form.category);
            formData.append('form_type', this.form.form_type);
            formData.append('client_id', this.$route.params.id);
            formData.append('image_url', 'this.form.file');
            formData.append('design_path', 'this.form.file');
            
            
            if(this.notifications) this.notifications = [];
            if (this.form.name_en) Axios.post(BACKEND_URL+'form', formData, {
                headers : {
                    'enctype' : 'multipart/form-data'
                }
            }).then((response) => {
                this.notifications.push({
                    type: 'success',
                    message: 'Form created successfully'
                });
            }, (response) => {
                this.notifications.push({
                    type: 'error',
                    message: 'Form not created'
                });
            });
        }
    },
    components: {
        'notification' : Notification
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}
button {
  
}
</style>



// WEBPACK FOOTER //
// create-form.vue?41dcb397